import { createNewsletterClient, type NewsletterClient } from '@codesocietyou/contentedge-newsletter-sdk';
import { hasValidNewsletterConfig } from '../config/cmsConfig';
import { getRuntimeConfig } from '../config/runtimeConfig';

export const NEWSLETTER_TIMEOUT_MS = 10_000;

export function newsletterBaseUrl(cmsApiUrl: string): string {
  const trimmed = cmsApiUrl.replace(/\/+$/, '');

  try {
    const url = new URL(trimmed);
    const path = url.pathname.replace(/\/+$/, '');
    if (path === '/api') {
      return url.origin;
    }
    return trimmed;
  } catch {
    return trimmed;
  }
}

export function getNewsletterClient(): NewsletterClient | undefined {
  const config = getRuntimeConfig();

  if (!hasValidNewsletterConfig(config)) {
    return undefined;
  }

  return createNewsletterClient({
    baseUrl: newsletterBaseUrl(config.CMS_API_URL),
    tenant: config.TENANT_NAME,
    formKey: config.NEWSLETTER_FORM_KEY,
    timeoutMs: NEWSLETTER_TIMEOUT_MS,
  });
}
